// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {type ModelPickerItemGroup, ModelPickerItemId, ModelPickerManufacturer} from './ModelPickerV2.types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IS_STORYBOOK = (import.meta as any)?.env?.STORYBOOK === 'true'

export const MANUFACTURER_ICONS: Record<ModelPickerManufacturer, string> = {
  OpenAI: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/openai-logo.svg`,
  Anthropic: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/anthropic.svg`,
  Google: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/gemini.svg`,
  xAI: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/xai.svg`,
}

export const COPY = {
  heading: 'Models',
  preview: 'Preview',
  signInCta: {
    label: 'Sign in',
    description: 'Sign in or create an account to explore available models',
  },
}

export const MODEL_PICKER_DATA: ModelPickerItemGroup[] = [
  {
    groupLabel: 'Fast and cost-efficient',
    items: [
      {id: ModelPickerItemId.GPT5Mini, label: 'GPT-5 mini', manufacturer: ModelPickerManufacturer.OpenAI, isFree: true},
      {
        id: ModelPickerItemId.GrokCodeFast1,
        label: 'Grok Code Fast 1',
        manufacturer: ModelPickerManufacturer.xAI,
        isFree: true,
      },
      {
        id: ModelPickerItemId.Gemini3Flash,
        label: 'Gemini 3 Flash',
        manufacturer: ModelPickerManufacturer.Google,
        isPreview: true,
      },
    ],
  },
  {
    groupLabel: 'Versatile and highly intelligent',
    items: [
      {id: ModelPickerItemId.GPT5, label: 'GPT-5', manufacturer: ModelPickerManufacturer.OpenAI},
      {id: ModelPickerItemId.GPT5_1, label: 'GPT-5.1', manufacturer: ModelPickerManufacturer.OpenAI},
      {id: ModelPickerItemId.Sonnet4, label: 'Claude Sonnet 4', manufacturer: ModelPickerManufacturer.Anthropic},
      {id: ModelPickerItemId.Sonnet4_5, label: 'Claude Sonnet 4.5', manufacturer: ModelPickerManufacturer.Anthropic},
      {
        id: ModelPickerItemId.Haiku4_5,
        label: 'Claude Haiku 4.5',
        manufacturer: ModelPickerManufacturer.Anthropic,
        isFree: true,
      },
      {id: ModelPickerItemId.GPT5_2, label: 'GPT-5.2', manufacturer: ModelPickerManufacturer.OpenAI},
      {id: ModelPickerItemId.GPT4_1, label: 'GPT-4.1', manufacturer: ModelPickerManufacturer.OpenAI, isFree: true},
      {id: ModelPickerItemId.GPT4o, label: 'GPT-4o', manufacturer: ModelPickerManufacturer.OpenAI},
    ],
  },
  {
    groupLabel: 'Most powerful at complex tasks',
    items: [
      {id: ModelPickerItemId.GPT5_1CodexMax, label: 'GPT-5.1-Codex-Max', manufacturer: ModelPickerManufacturer.OpenAI},
      {id: ModelPickerItemId.Opus4_5, label: 'Claude Opus 4.5', manufacturer: ModelPickerManufacturer.Anthropic},
      {id: ModelPickerItemId.Opus4_1, label: 'Claude Opus 4.1', manufacturer: ModelPickerManufacturer.Anthropic},
      {
        id: ModelPickerItemId.Gemini3Pro,
        label: 'Gemini 3 Pro',
        manufacturer: ModelPickerManufacturer.Google,
        isPreview: true,
      },
      {id: ModelPickerItemId.Gemini2_5Pro, label: 'Gemini 2.5 Pro', manufacturer: ModelPickerManufacturer.Google},
    ],
  },
]
